import * as yup from 'yup';

export const DAY_LABELS = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const SERVICE_TYPES = [
  { value: 'J', label: 'J - Passenger' },
  { value: 'F', label: 'F - Cargo' },
  { value: 'C', label: 'C - Charter' },
];

export const STATUS_OPTIONS = ['planned', 'active', 'cancelled'];

export const AC_TYPE_COLORS = ['primary', 'secondary', 'success', 'warning', 'info', 'error'];

export const AC_HEX = ['#1976d2','#388e3c','#f57c00','#7b1fa2','#c62828','#00838f','#558b2f','#ad1457'];

export const toMin = (hhmm = '') => {
  const [h, m] = (hhmm || '00:00').split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const autoColon = (raw = '') => {
  const d = raw.replace(/[^0-9]/g, '');
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}:${d.slice(2, 4)}`;
};

export const flightSchema = yup.object({
  seasonId: yup.string().required('Season is required'),
  flightNo: yup.string().required('Flight number is required'),
  carrier: yup.string().required('Carrier is required'),
  dep: yup.string().length(3, 'Must be 3 letters').required('Departure required'),
  arr: yup.string().length(3, 'Must be 3 letters').required('Arrival required'),
  std: yup.string().matches(/^\d{2}:\d{2}$/, 'Format HH:MM').required('STD required'),
  sta: yup.string().matches(/^\d{2}:\d{2}$/, 'Format HH:MM').required('STA required'),
  daysOfOperation: yup.string().min(1, 'Select at least one day').required('Days of operation required'),
  acType: yup.string(),
  serviceType: yup.string(),
  status: yup.string(),
});

export const publishSchema = yup.object({
  fromDate: yup.string().required('From date is required'),
  toDate: yup.string().required('To date is required'),
});
